import { BillPaymentStatusSchema } from "@src/sudozi-schemas/bill-payment-status-schema";
import { IntakeCategoryType } from "@src/sudozi-schemas/intake-submission-schemas";
import { RequestStatusSchema } from "@src/sudozi-schemas/request-status-schema";
import z from "zod";

export const PurchaseOrderSchema = z.object({
  id: z.string(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  syncedOn: z.string().nullable(),
  erpId: z.string().nullable(),
  erpReadableId: z.string().nullable(),
  status: z.enum(["OPEN", "CLOSED"]),
  totalAmount: z.number(),
  memo: z.string(),
  levelGroupStatus: z.object({
    approvedBy: z
      .object({
        id: z.string(),
        firstName: z.string(),
        lastName: z.string(),
        email: z.string(),
      })
      .nullable(),
    intakeSubmission: z
      .object({
        id: z.string(),
        createdAt: z.string().datetime(),
        title: z.string().nullable(),
        number: z.number(),
        status: RequestStatusSchema,
        bills: z.array(
          z.object({
            id: z.string(),
            totalAmount: z.number(),
            createdAt: z.string().datetime(),
            dueDate: z.string(),
            description: z.string(),
            invoiceDate: z.string(),
            invoiceNumber: z.string(),
            status: RequestStatusSchema,
            accountingPeriod: z
              .object({
                startYearMonthDay: z.string(),
                endYearMonthDay: z.string(),
              })
              .nullable(),
            erpVendor: z.object({
              id: z.string(),
              name: z.string(),
            }),
            billPayment: z
              .object({
                status: BillPaymentStatusSchema,
                paidAt: z.string().datetime().nullable(),
              })
              .nullable(),
          }),
        ),
        intakeCategory: z.object({
          id: z.string(),
          name: z.string(),
          type: IntakeCategoryType,
        }),
        amount: z.number(),
      })
      .nullable(),
  }),
  erpVendor: z
    .object({
      id: z.string(),
      name: z.string(),
      status: z.enum(["ACTIVE", "PENDING", "INACTIVE"]),
    })
    .nullable(),
  erpEntity: z
    .object({
      id: z.string(),
      name: z.string(),
    })
    .nullable(),
  erpLocation: z
    .object({
      id: z.string(),
      name: z.string(),
    })
    .nullable(),
  erpDepartment: z
    .object({
      id: z.string(),
      name: z.string(),
    })
    .nullable(),
  erpClassification: z
    .object({
      id: z.string(),
      name: z.string(),
    })
    .nullable(),
  lines: z.array(
    z.object({
      amount: z.number(),
      description: z.string(),
      erpAccount: z.object({
        id: z.string(),
        name: z.string(),
      }),
      erpDepartment: z
        .object({
          id: z.string(),
          name: z.string(),
        })
        .nullable(),
      erpClassification: z
        .object({
          id: z.string(),
          name: z.string(),
        })
        .nullable(),
      erpLocation: z
        .object({
          id: z.string(),
          name: z.string(),
        })
        .nullable(),
    }),
  ),
});

export type PurchaseOrder = z.infer<typeof PurchaseOrderSchema>;
